module.exports = "/_next/static/images/google-store-icon-5db8efbc10026e1b4303c8c0d8e0d2ff.svg";